import React, { useMemo } from "react";
import { PropertyRoom } from "../../../../definitions/property";
import Flex from "../../../structure/Flex";
import RoomCard from "../RoomCard";

interface RoomsListProps {
  rooms: Array<PropertyRoom>;
  roomCounts: { [key: string]: number };
  getRoomCountSetter: (roomRef: string) => (count: number) => void;
  loadingAvailability: boolean;
  operatorCode?: string;
  checkInDate?: string;
  checkOutDate?: string;
  setGalleryVisible?: any;
  setGalleryData?: any;
  selectedRoomId?: number | null;
}

const roomSorter = (roomA: any, roomB: any, selectedRoomId?: number | null) => {
  // If one of the rooms matches the selected room ID, prioritize it
  if (selectedRoomId) {
    if (roomA.id === selectedRoomId) return -1;
    if (roomB.id === selectedRoomId) return 1;
  }

  let priority = 0;
  if (roomA.availability != null && roomB.availability != null) {
    if (!roomA.availability.isAvailable && !roomB.availability.isAvailable) {
      priority = -1;
    } else if (
      roomA.availability.isAvailable &&
      !roomB.availability.isAvailable
    ) {
      priority = -1;
    } else if (
      !roomA.availability.isAvailable &&
      roomB.availability.isAvailable
    ) {
      priority = 1;
    } else {
      priority = roomB.priority - roomA.priority;
    }
  }
  return priority;
};

const RoomsList: React.FC<RoomsListProps> = ({
  rooms,
  roomCounts,
  getRoomCountSetter,
  loadingAvailability,
  operatorCode,
  checkInDate,
  checkOutDate,
  setGalleryVisible,
  setGalleryData,
  selectedRoomId,
}) => {
  const sortedRooms = useMemo(
    () => rooms.sort((a, b) => roomSorter(a, b, selectedRoomId)),
    [rooms, selectedRoomId]
  );

  return useMemo(
    () => (
      <>
        {rooms.length > 0 ? (
          sortedRooms.map((room) => (
            <RoomCard
              key={room._ref}
              loadingAvailability={loadingAvailability}
              room={room}
              count={roomCounts[room._ref]}
              operatorCode={operatorCode}
              checkInDate={checkInDate}
              checkOutDate={checkOutDate}
              setCount={getRoomCountSetter(room._ref)}
              setGalleryVisible={setGalleryVisible}
              setGalleryData={setGalleryData}
            />
          ))
        ) : (
          <Flex
            className="w-full py-8 font-medium text-subtitle sm:pt-20"
            justify="center"
            items="center"
          >
            No rooms available
          </Flex>
        )}
      </>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sortedRooms, roomCounts, operatorCode, checkInDate, loadingAvailability]
  );
};

export default RoomsList;
